<template>
  <div style="background-color: #ffffff;">
    <el-tabs v-if="mainObj.project_id" type="border-card" v-model="isEditor" class="meterMap">
      <el-tab-pane label="查看" name="view">
        <el-button size="mini" @click="download">下 载</el-button>
        <MeterViewDiagram2 ref="MeterViewDiagram" v-if="isEditor==='view'" :is-editor="false" @onClickMeter="onClickMeter" @onClickMeterId="onClickMeterId"/>
      </el-tab-pane>
      <el-tab-pane label="编辑" name="editor">
        <MeterViewDiagram2 ref="MeterViewDiagram" v-if="isEditor==='editor'" :is-editor="true" @onClickMeter="onClickMeter" @onClickMeterId="onClickMeterId"/>
      </el-tab-pane>
<!--      <el-tab-pane label="极简编辑" name="editorSimple">-->
<!--        <MeterViewSimpleDiagram ref="MeterViewDiagram" v-if="isEditor==='editorSimple'" :is-editor="true" @onClickMeter="onClickMeter" @onClickMeterId="onClickMeterId"/>-->
<!--      </el-tab-pane>-->
    </el-tabs>
  </div>
</template>

<script>
import MeterViewDiagram2 from "./MeterViewDiagram2";
import MeterViewSimpleDiagram from "./MeterViewSimpleDiagram";
import MeterHttp from "../../../common/MeterHttp";
export default {
  name: "MeterMapEditor2",
  provide(){
    return{
      mainObj:this.mainObj,
      componentId:this.componentId,
      setComponentId:this.setComponentId,
    }
  },
  components: {MeterViewDiagram2,MeterViewSimpleDiagram},
  props:{
    meterId:[Number,String]
  },
  data(){
    return{
      meter_id:null,
      excel_list2:[],
      mainObj:{
        house_name:"",
        house_id:"",
        project_id:"",
        id:"",
        map_id:"",
        type:""
      },
      isEditor:"view",
      componentId:"MeterMain",
    }
  },
  mounted() {
    const that=this;
    let meter_id=that.$route.query.meterId;
    that.meter_id=meter_id;
    that.mainObj.map_id=meter_id;
    that.mainObj.project_id=that.$route.query.projectId;
  },
  methods:{
    show(meter_id,callback){
      const that=this;
      that.meter_id=meter_id;
      that.onLoad(callback);
    },
    onClose(){

    },
    onLoad(callback){
      const that=this;
      MeterHttp.post("Meter/getMapTree?user_type="+(that.$route.query.type||0),{
        project_id:that.mainObj.project_id,
        meter_id:that.meter_id,
        is_editor:0,
      },ret=>{
        if(ret.code){
          that.excel_list2=ret.data;
        }else {
          that.$message.error(ret.msg||"数据异常")
        }
        typeof callback==="function"&&callback(ret)
      })
    },
    download(){
      this.$refs.MeterViewDiagram.download();
    },
    onClickMeter(node){
      const that=this;
      that.show(node.id,function () {
        setTimeout(function () {
          that.$refs.MeterViewDiagram.reData()
        },500)
      });
    },
    onClickMeterId(id){
      const that=this;
      that.show(id,function () {
        setTimeout(function () {
          that.$refs.MeterViewDiagram.reData()
        },500)
      });
    },
    setComponentId(componentId){
      this.componentId=componentId;
    },
  },
}
</script>

<style lang="scss" scoped>
.dialog-1{
  >>>.el-dialog__body{
    padding: 0;
  }
  >>>.el-dialog__header{
    padding: 0;
  }
}
.meterMap{
  >>>.el-tabs__content{
    padding: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/EnergyConsumption/components/meter/components/MeterMapEditor2.vue